module.exports = __webpack_public_path__ + "img/receipt.95de19c6.svg";